import styled from 'styled-components';

import { AnimatedNumber } from '#src/atoms/animations/AnimatedNumber/index.tsx';
import { ButtonBase } from '#src/atoms/buttons/ButtonBase/index.tsx';
import { GemIcon } from '#src/atoms/icons/GemIcon.tsx';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { LabelM } from '#src/atoms/typography/index.tsx';
import { DialogKey } from '#src/components/navigation/WithDialogs/index.tsx';
import { useOpenDialog } from '#src/hooks/navigation/useOpenDialog.ts';
import { useEvents } from '#src/lib/events/useEvents.ts';
import { OpenBuyGemsDialog_Context } from '#src/protos/events/platform/web/events.ts';

const IconWrapper = styled(Horizontal).attrs({ center: true })`
  width: var(--triple-unit);
  height: var(--triple-unit);
  border-radius: 50%;
  background: var(--c-nl-800);

  & > img {
    height: 16px;
    object-fit: contain;
  }
`;

const Root = styled(ButtonBase)`
  border-radius: var(--double-unit);
  padding-left: var(--unit);
  background: var(--c-nl-500);
  display: flex;
  &:hover {
    background: var(--c-nl-600);
  }
`;

type Props = { balance: number };
export const GemsBalance = ({ balance }: Props) => {
  const track = useEvents();
  const openDialog = useOpenDialog();

  return (
    <Root
      onClick={() => {
        track('Open Buy Gems Dialog', {
          context: OpenBuyGemsDialog_Context.GEMS_BALANCE,
        });
        openDialog(DialogKey.buyGems, 'true');
      }}
    >
      <Horizontal gap={0.5}>
        <LabelM bold>
          <AnimatedNumber value={balance} disableAnimationOnFirstRender />
        </LabelM>
        <IconWrapper>
          <GemIcon />
        </IconWrapper>
      </Horizontal>
    </Root>
  );
};
